import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// State
import { setCheckoutDeliveryType } from '../../../state/modules/order/actions';

// Icons
import GiftIcon from '../../../icons/gift.svg';

// Styles
import styles from './DeliveryTypeSwitcher.styl';

const cx = classNames.bind(styles);

export default function DeliveryTypeSwitcher(props) {
  const { className } = props;
  const { isApplying } = useSelector(state => state.stock);

  const intl = useIntl();
  const dispatch = useDispatch();
  const unit = useSelector(state => state.city.userCity.currency.unit);
  const pickupBonuses = useSelector(state => state.stock.unconditionalList.data.rewards?.[0]);
  const deliveryType = useSelector(state => state.order.checkout.deliveryType);

  const deliveryTypes = [
    { label: intl.formatMessage({ id: 'order.delivery.title' }), value: 'delivery' },
    { label: intl.formatMessage({ id: 'order.pickup.title' }), value: 'pickup' },
  ];

  const handleOnClick = newValue => {
    if (newValue !== deliveryType) {
      dispatch(setCheckoutDeliveryType(newValue));
    }
  };

  return (
    <div className={cx('DeliveryTypeSwitcher', className)}>
      <div
        className={cx('DeliveryTypeSwitcher__selector', {
          DeliveryTypeSwitcher__selector_pickup: deliveryType === 'pickup',
          DeliveryTypeSwitcher__selector_disable: isApplying,
        })}
      />
      {deliveryTypes.map(({ label, value }) => (
        <button
          disabled={isApplying}
          key={label}
          className={cx('DeliveryTypeSwitcher__item', {
            DeliveryTypeSwitcher__item_active: deliveryType === value,
            DeliveryTypeSwitcher__item_disable: isApplying,
          })}
          onClick={() => handleOnClick(value)}
          onKeyDown={e => e.key === 'Enter' && handleOnClick(value)}
          type="button"
        >
          <div className={cx('DeliveryTypeSwitcher__subtitle')}>{label}</div>
          {value === 'pickup' && pickupBonuses && (
            <div className={cx('DeliveryTypeSwitcher__promo')}>
              {pickupBonuses.reward === 'order_discount' ? (
                `${pickupBonuses.reward_value}${
                  pickupBonuses.type === 'percent' ? '%' : ` ${unit}`
                }`
              ) : (
                <GiftIcon />
              )}
            </div>
          )}
        </button>
      ))}
    </div>
  );
}

DeliveryTypeSwitcher.defaultProps = {
  className: '',
};

DeliveryTypeSwitcher.propTypes = {
  className: PropTypes.string,
};
